import { useTranslation } from 'react-i18next'
import { css } from 'styled-components'

import { Dialog, type DialogProps } from '@root/shared/ui-kit'

import { TransactionDetails } from '../../transaction-details/transaction-details'

import type { Transaction } from '@root/entities/transaction'

type Props = Pick<DialogProps, 'onOpenChange' | 'open'> & {
  tx: Transaction.Transaction
}

export const TransactionDetailsDialog: React.FC<Props> = ({
  open,
  onOpenChange,
  tx,
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      describedBy={t('transaction.transaction_details')}
    >
      <Dialog.Header.Functional title={t('transaction.transaction_details')} />
      <Dialog.Content.Functional $variant={0}>
        <TransactionDetails
          tx={tx}
          css={css`
            padding-block: 16px 0;
            min-width: 400px;
          `}
        />
      </Dialog.Content.Functional>
    </Dialog>
  )
}
